import React, { useState, useEffect, useCallback } from 'react';
import MultiCheckboxComponent from './MultiCheckbox';

const CheckboxField = ({ field, updateGlobalFilter, initialSelectedOptions = [], componentClass = "flex flex-col text-lg leading-6" }) => {
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);

  useEffect(() => {
    const selectedTitles = field.fields_checkboxes
      .filter((_, idx) => selectedOptions.includes(idx))
      .map(checkbox => checkbox.title);
    updateGlobalFilter(field.field, selectedTitles);
  }, [selectedOptions, field, updateGlobalFilter]);

  const onFilterChange = useCallback((optionId) => {
    setSelectedOptions(prevSelectedOptions => {
      return prevSelectedOptions.includes(optionId)
        ? prevSelectedOptions.filter(id => id !== optionId)
        : [...prevSelectedOptions, optionId];
    });
  }, []);

  return (
    <div className="mb-4">
      <h4 className="font-bold mb-2 text-lg">{field.title}</h4>
      <MultiCheckboxComponent
        options={field.fields_checkboxes.map((checkbox, cbIndex) => ({
          id: cbIndex,
          name: checkbox.title,
        }))}
        selected={selectedOptions}
        onChange={onFilterChange}
        fieldId={field.uniqueId}
        componentClass={componentClass}
      />
    </div>
  );
};

export default CheckboxField;